import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DocumentContext, { newContext } from './DocumentContext';
import './index.css';

const dimensions = {
  portrait: {
    height: 1570,
  },
  landscape: {
    height: 1140,
  },
};

const portraitOritentation = 'portrait';
const landscapeOrientation = 'landscape';

const Document = ({
  children, orientation, firstHeader, repeatedHeader,
}) => (
  <div className="printable printable-document">
    <div className="printable printable-document-container">
      <DocumentContext.Provider
        value={newContext(repeatedHeader, dimensions[orientation].height)}
      >
        {firstHeader}
        {children}
      </DocumentContext.Provider>
    </div>
  </div>
);

Document.propTypes = {
  children: PropTypes.node,
  orientation: PropTypes.string,
  firstHeader: PropTypes.node,
  repeatedHeader: PropTypes.node,
};

Document.defaultProps = {
  children: <Fragment />,
  orientation: portraitOritentation,
  firstHeader: <Fragment />,
  repeatedHeader: <Fragment />,
};

export default Document;

export { portraitOritentation, landscapeOrientation };
